// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  envName: 'dev',
  firebase: {
    apiKey: 'AIzaSyA0bA73rbjEMCFU8Ktrudbla7vGthTK9dk',
    authDomain: 'dashboard-dev-a2726.firebaseapp.com',
    databaseURL: 'https://dashboard-dev-a2726.firebaseio.com',
    projectId: 'dashboard-dev-a2726',
    storageBucket: 'dashboard-dev-a2726.appspot.com',
    messagingSenderId: '267651482961'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
